import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const TenantAuthContext = createContext(null);

export function TenantAuthProvider({ children }) {
  const [tenant, setTenant] = useState(null); // null=checking, false=not auth, obj=auth

  const refetch = useCallback(async () => {
    try {
      const { data } = await api.get("/tenant/auth/me");
      setTenant(data);
    } catch {
      setTenant(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  const login = useCallback(async (login_code, pin) => {
    try {
      await api.post("/tenant/auth/login", { login_code, pin });
      await refetch();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, [refetch]);

  const logout = useCallback(async () => {
    try { await api.post("/tenant/auth/logout"); } catch {}
    setTenant(false);
  }, []);

  return (
    <TenantAuthContext.Provider value={{ tenant, login, logout, refetch }}>
      {children}
    </TenantAuthContext.Provider>
  );
}

export function useTenantAuth() {
  return useContext(TenantAuthContext);
}
